module.exports = __webpack_public_path__ + "static/media/card-3.a71404c4.svg";